import PropTypes from 'prop-types';

const FaqCategory = {
  name: PropTypes.string,
  slug: PropTypes.string,
  isPopular: PropTypes.bool,
  faqs: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.shape({
        name: PropTypes.string,
        slug: PropTypes.string,
      }),
      answer: PropTypes.any,
    }),
  ),
};

export default FaqCategory;
